import React, { useState, useEffect } from 'react';
import { User, Plus, Trash2, Loader2 } from 'lucide-react';
import { auth } from '../config/firebase';
import { profissionalService } from '../services/api';
import PaywallCard from './PaywallCard';

const GerenciarEquipe = ({ temAcesso }) => {
  const isEmpresarial = temAcesso('gerenciar_equipe');
  const [profissionais, setProfissionais] = useState([]);
  const [loading, setLoading] = useState(true);
  const [nome, setNome] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const carregarEquipe = async () => {
    try {
      const user = auth.currentUser;
      if (user) {
        const res = await profissionalService.listar(user.uid);
        setProfissionais(res.data || []);
      }
    } catch (error) {
      console.error("Erro ao carregar equipe:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isEmpresarial) carregarEquipe();
    else setLoading(false);
  }, [isEmpresarial]);

  const handleSalvar = async (e) => {
    e.preventDefault();
    if (!nome.trim()) return;
    
    setIsSubmitting(true);
    try {
      const user = auth.currentUser;
      await profissionalService.criar({ usuario_id: user.uid, nome });
      setNome('');
      await carregarEquipe();
    } catch (error) {
      alert("Erro ao salvar profissional.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeletar = async (id) => {
    if (!window.confirm("Remover este profissional?")) return;
    try {
      const user = auth.currentUser;
      await profissionalService.deletar(id, user.uid);
      await carregarEquipe();
    } catch (error) {
      alert("Erro ao remover profissional.");
    }
  };

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-10 text-slate-400">
        <Loader2 className="animate-spin mb-2" size={24} />
        <p className="text-xs font-bold uppercase tracking-widest">Carregando equipe...</p>
      </div>
    );
  }

  if (!isEmpresarial) {
    return (
      <PaywallCard
        titulo="Gerenciar Equipe"
        descricao="Cadastre profissionais da sua equipe e organize múltiplos atendentes."
        plano="Empresarial"
      />
    );
  }

  return (
    <div className="animate-fade-in-up w-full">
      <div className="flex items-center gap-3 mb-6 border-b border-purple-50 pb-4">
        <User size={18} className="text-[#1883FF]" />
        <h3 className="text-sm font-black uppercase italic text-slate-900 m-0">Equipe Técnica</h3>
      </div>

      <form onSubmit={handleSalvar} className="flex gap-2 mb-6">
        <input 
          required 
          type="text"
          className="flex-1 bg-[#F8F7FF] border border-purple-50 py-3 px-4 rounded-xl text-sm font-bold text-slate-900 outline-none transition-all focus:bg-white focus:border-[#6D28D9] focus:ring-4 focus:ring-[#6D28D9]/10"
          placeholder="Nome do profissional (Ex: Dra. Julia)"
          value={nome} 
          onChange={e => setNome(e.target.value)}
        />
        <button 
          type="submit" 
          disabled={isSubmitting} 
          className="bg-[#1883FF] text-white px-4 rounded-xl font-black cursor-pointer hover:bg-[#6D28D9] transition-all disabled:opacity-50"
        >
          {isSubmitting ? <Loader2 size={18} className="animate-spin" /> : <Plus size={18} />}
        </button>
      </form>

      <div className="flex flex-col gap-2">
        {profissionais.length === 0 ? (
          <p className="text-xs text-slate-400 italic text-center py-4">Nenhum profissional cadastrado.</p>
        ) : (
          profissionais.map(p => (
            <div key={p.id} className="flex justify-between items-center bg-white p-4 rounded-xl border border-slate-100 shadow-sm hover:border-purple-100 transition-all">
              <span className="text-sm font-bold text-slate-700">{p.nome}</span>
              <button 
                onClick={() => handleDeletar(p.id)} 
                className="bg-red-50 text-red-500 p-2 rounded-lg hover:bg-red-100 transition-colors"
              >
                <Trash2 size={16} />
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default GerenciarEquipe;